import { render } from "./AddModalZone.vue?vue&type=template&id=4e24d8ac&ts=true"
import script from "./AddModalZone.vue?vue&type=script&lang=ts"
export * from "./AddModalZone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__